import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

window.addEventListener("load", () => {
    let selector = ".WheelOfTasksComponent .title";
    const cookie = document.cookie
        .split('; ')
        .some(item => item === 'spinned=true');

    if (cookie === true) {
        selector = ".WheelOfTasksComponent .title, .OverviewComponent .title"
    }

    let titles = document.querySelectorAll<HTMLElement>(selector)


    titles.forEach(title => {
      animateTitle(title);
    })
});

export function animateTitle(title: HTMLElement) {
    let SplitClient = SplitText.create(title, { type: "chars"});
    const tl = gsap.timeline()
    tl.from (SplitClient.chars, {
        scrollTrigger: {
            trigger: title,
            scrub: 1,
            start: 'bottom bottom',
            end: 'center center',
            //markers: true,
        },
        yPercent: -100,
        opacity: 0,
        stagger: 0.05
    })
}